const UrlService = {
    getAbsoluteUrlForPathSegment: (url) => {
        return url + '?' + window.location.hash.split('?')[1];
    },
};
export default UrlService;
